import React from "react"

import "./pro_feature_check.scss"

interface Props {
  billingUrl: string
  expirationDate: string
  assets: object
  moveNextView: func
  tierName: string
}

const ProFeatureCheck = ({ billingUrl, expirationDate, assets, moveNextView, tierName }: Props) => {
  const proFeatures = (
    <>
      <li styleName="feature">
        <div styleName="icon">
          <img src={assets.pro.applets} width="121" height="80" />
        </div>
        <h4>Applets</h4>
      </li>
      <li styleName="feature" className="mt4--phone">
        <div styleName="icon">
          <img src={assets.pro.speed} width="96" height="65" />
        </div>
        <h4>Fastest Applet<br/>speeds</h4>
      </li>
      <li styleName="feature" className="mt4--phone">
        <div styleName="icon">
          <img src={assets.pro.multiAction} width="76" height="76"/>
        </div>
        <h4>Multi-action<br/>Applets</h4>
      </li>
    </>
  )

  const proPlusFeatures = (
    <>
      <li styleName="feature">
        <div styleName="icon">
          <img src={assets.pro_plus.unlimitedApplets} width="105" height="80" />
          </div>
        <h4>Unlimited<br/>Applets</h4>
      </li>
      <li styleName="feature" className="mt4--phone">
        <div styleName="icon">
          <img src={assets.pro_plus.multipleAccounts} width="80" height="80" />
        </div>
        <h4>Multiple<br/>accounts</h4>
      </li>
      <li styleName="feature" className="mt4--phone">
        <div styleName="icon">
          <img src={assets.pro_plus.queriesAndFilterCode} width="93" height="80" />
        </div>
        <h4>Queries and<br/>filter code</h4>
      </li>
      <li styleName="feature" className="mt4--phone">
        <div styleName="icon">
          <img src={assets.pro_plus.everythingInPro} width="102" height="70" />
        </div>
        <h4>Everything<br/>in Pro</h4>
      </li>
    </>
  )

  return (
    <div styleName="pro_feature_check">
      <h1 className="mt4 mb4 mb2--phone mb2--small-phone">Cancel {tierName}</h1>

      <p className="txt-body-2 mb8 m0--phone">On {expirationDate} you will be moved to our free plan and lose access to all IFTTT {tierName} benefits like:</p>

      <ul styleName="feature_list" className="p4">
        {tierName === "Pro+" ? proPlusFeatures : proFeatures }
      </ul>

      <div className="cancellation-actions mt16 mt8--phone mt8--small-phone">
        <a className="button-primary" href={billingUrl}>Stay {tierName}</a>
        <a className="link-standalone mt4" onClick={moveNextView}>Continue with cancellation</a>
      </div>
    </div>
  )
}

export default ProFeatureCheck
